var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-material-card',{staticClass:"px-6",attrs:{"icon":"mdi-chat-question","title":`Summary #${_vm.item.id}`}},[(!_setup.isArticleContentMetaV2)?_c('p',[_vm._v("This article doesn't have the path field, so summary can't be generated")]):_c('v-btn',{on:{"click":_setup.createSummary}},[_vm._v("Generate Summary")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }